export default __webpack_public_path__ + "static/Hospitality-hero-8ccf544bf5dd0805698d2267c48cf869.png";